import { Plan, PlanStack, PlanTypeEnum, Size, TooltipPosition } from "@/types";

export const getEdgePlansByTask = (
  plans: Plan[],
  selectedTasks: number,
  isFree: boolean
) => {
  const minPlan = plans[0];
  const maxPlan = plans[plans.length - 1];
  const isTaskTooLow = selectedTasks < minPlan.tasks;
  const isTaskTooHigh = selectedTasks > maxPlan.tasks;
  const hasTaskTier =
    !selectedTasks || selectedTasks === 0 || isFree
      ? true
      : !isTaskTooLow && !isTaskTooHigh;
  return {
    minPlan,
    maxPlan,
    isTaskTooLow,
    isTaskTooHigh,
    hasTaskTier,
  };
};

export const getHasPlanInRange = (
  planStacks: PlanStack[],
  selectedTasks: number
) => {
  return Boolean(
    planStacks
      .find((pS) => pS.planType === PlanTypeEnum.Company)
      ?.plans.some((p) => p.tasks >= selectedTasks)
  );
};

export const getTooltipPosition = (
  index: number,
  size: Size,
  collectionLength: number
): TooltipPosition => {
  const max = { small: 1, medium: 3, large: 5 }[size];

  if (size === "small" || index === 0 || index % max === 0) {
    return "northwest";
  }

  if (
    (collectionLength <= max && index === collectionLength - 1) ||
    (index + 1) % max === 0
  ) {
    return "northeast";
  }

  return "north";
};
